import { useContext } from "react";
import { useInfiniteQuery } from "react-query";
import { AxiosContext } from "services/axios.context";
import { AuthenticationContext } from "services/authentication.context";

export const useTours = (params = {}, size = 4) => {
  const { isAuthenticated } = useContext(AuthenticationContext);
  const { client } = useContext(AxiosContext);
  const axios = isAuthenticated ? client : client;

  return useInfiniteQuery(
    ["tours", params],
    ({ pageParam = 1 }) =>
      axios
        .get(`tours/?page=${pageParam}&size=${size}`, {
          params: params,
        })
        .then((resp) => {
          console.debug(`🏟 Tours }`);
          return resp.data;
        }),
    {
      enabled: true,
      staleTime: 300000,
      refetchOnWindowFocus: true,
      getNextPageParam: (lastPage) =>
        lastPage.total / lastPage.size > lastPage.page
          ? lastPage.page + 1
          : null,
    }
  );
};
